import { regexNumber, regexPhone } from '@/utils/utils';
import { styled, TextField, TextFieldProps } from '@mui/material';
import React, { memo } from 'react';

function InputCustom(
  props: TextFieldProps & {
    register?: any;
  },
) {
  const { register, onChange, onBlur, ...otherProps } = props;

  const onKeyPress = (e: any) => {
    if (props.type === 'number' && !(e.key <= 9 && e.key >= 0)) {
      e.preventDefault();
    }

    if (props.type === 'tel' && !(e.key <= 9 && e.key >= 0) && e.key !== '+') {
      e.preventDefault();
    }
  };

  const onPaste = (e: any) => {
    const text = e.clipboardData.getData('text/plain').replaceAll(' ', '');
    if (props.type === 'number' && !regexNumber.test(text)) {
      e.preventDefault();
    }

    if (props.type === 'tel' && !regexPhone.test(text)) {
      e.preventDefault();
    }
  };

  return (
    <StyledTextField
      {...register}
      {...otherProps}
      onChange={(e: any) => {
        onChange && onChange(e);
        register.onChange(e);
      }}
      onBlur={(e: any) => {
        onBlur && onBlur(e);
        register.onBlur(e);
      }}
      onKeyPress={onKeyPress}
      onPaste={onPaste}
      onWheel={(e: any) => e.target.blur()}
    />
  );
}

export default memo(InputCustom);
const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  height: 'auto',
  width: '100%',
  label: {
    lineHeight: 'unset',
    top: '-2px',
  },

  // css for TextField
  '.MuiOutlinedInput-root': {
    height: '48px',
    paddingLeft: '16px',
    fontSize: '14px',
    lineHeight: '16px',

    '&.Mui-focused': {
      '.MuiInputAdornment-root': {
        '& svg': {},
      },
    },

    '.MuiInputAdornment-root': {
      margin: '0px',

      '& svg': {
        height: '20px',
        width: '20px',
      },
    },

    input: {
      height: '100%',
      padding: '0px 16px 0px 12px',

      '&::placeholder': {},
    },

    fieldset: {
      borderRadius: '0px',
    },

    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,

      '& input': {
        cursor: 'not-allowed',
        color: theme.palette.text.disabled,
      },

      '& fieldset': {
        borderColor: theme.palette.action.disabled,
      },

      '& .MuiInputAdornment-root': {
        color: theme.palette.text.disabled,
      }
    },
  },

  '& .MuiFilledInput-root': {
    height: 48,
    fontWeight: 500,
    overflow: 'hidden',
    borderRadius: 0,
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '1px solid #D4D4D4',
    boxShadow: 'unset',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:before': {
      borderBottom: 'unset',
    },
    '&:after': {
      borderBottom: 'unset',
    },
    '&:hover': {
      borderBottom: `1px solid ${theme.palette.white[80]}`,
      backgroundColor: 'transparent',

      '&:before': {
        borderBottom: 'unset!important',
      },
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderBottomColor: theme.palette.primary.main,
    },
    '&.Mui-readOnly': {
      '&:hover': {
        borderBottomColor: `1px solid #E0E3E7`,
        backgroundColor: 'transparent',
        boxShadow: 'unset',
        '&::before': {
          border: 'unset',
        },
      },
      '&:before': {
        borderBottom: 'unset',
      },
    },
    '&.Mui-error': {
      borderBottomColor: theme.palette.error.main,
    },
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,
      borderBottomColor: theme.palette.action.disabled,

      '& input': {
        cursor: 'not-allowed',
        color: theme.palette.text.disabled,
      },

      '& .MuiInputAdornment-root': {
        color: theme.palette.text.disabled,
      }
    }
  },

  [theme.breakpoints.down('sm')]: {
    '.MuiOutlinedInput-root': {
      fontSize: 'unset',
      lineHeight: 'unset',
    },
  },
}));
